/**
 * Debounce for live-event buttons: after a tap the button ignores further
 * taps for a short lock period, so an accidental double tap runs the handler
 * exactly once. Handlers may be async (confirm dialogs); the lock is held
 * until they settle, at least `lockMs`.
 */
export function guardTap(
  button: HTMLButtonElement,
  handler: () => void | Promise<void>,
  lockMs = 600,
): void {
  let locked = false;
  button.addEventListener('click', (ev) => {
    ev.preventDefault();
    if (locked) return;
    locked = true;
    const started = Date.now();
    const release = () => {
      const wait = Math.max(0, lockMs - (Date.now() - started));
      setTimeout(() => {
        locked = false;
      }, wait);
    };
    Promise.resolve()
      .then(handler)
      .catch((err) => console.error('button handler failed', err))
      .finally(release);
  });
}
